var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Processing",
    { staticClass: "flex", attrs: { processing: _vm.processing } },
    [
      _c(
        "div",
        {
          staticClass: "customProjectTasks",
          class: {
            greenBorder:
              _vm.project.enable_visit_based_clock_ins &&
              _vm.activity.accepted &&
              !_vm.activity.completed &&
              !_vm.isClockedOut &&
              _vm.isCurrentClockType === "OUT",
          },
          attrs: { warning: _vm.warningShown },
        },
        [
          _c(
            "div",
            { staticClass: "flex w-auto w-full flex-col containerTop" },
            [
              _c("div", { staticClass: "flex flex-col gap-3.5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-row justify-between items-center h-8",
                  },
                  [
                    _c("p", {
                      staticClass:
                        "text-sm leading-normal font-400 text-storm-gray",
                    }),
                    _vm.isWithinClockInWindow &&
                    _vm.project.enable_visit_based_clock_ins &&
                    this.activity.accepted &&
                    !this.activity.completed &&
                    !_vm.isClockedOut &&
                    _vm.isCurrentClockType === "IN"
                      ? _c("UIButton", {
                          staticClass: "font-outfit",
                          attrs: {
                            buttonText: "Clock-in",
                            variant: "black",
                            size: "md",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleContractorClockInModal(true)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "icon",
                                fn: function () {
                                  return [
                                    _c("ClockIcon", { staticClass: "w-4 h-4" }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "hover-icon",
                                fn: function () {
                                  return [
                                    _c("ClockIconBlack", {
                                      staticClass: "w-4 h-4",
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "disabled",
                                fn: function () {
                                  return [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 16 16",
                                          fill: "none",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              "clip-path":
                                                "url(#clip0_1989_5285)",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM7.25 3.75V8C7.25 8.25 7.375 8.48438 7.58437 8.625L10.5844 10.625C10.9281 10.8562 11.3938 10.7625 11.625 10.4156C11.8562 10.0687 11.7625 9.60625 11.4156 9.375L8.75 7.6V3.75C8.75 3.33437 8.41562 3 8 3C7.58437 3 7.25 3.33437 7.25 3.75Z",
                                                fill: "#717986",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("defs", [
                                          _c(
                                            "clipPath",
                                            {
                                              attrs: { id: "clip0_1989_5285" },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  width: "16",
                                                  height: "16",
                                                  fill: "white",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1773076975
                          ),
                        })
                      : _vm._e(),
                    _vm.project.enable_visit_based_clock_ins &&
                    this.activity.accepted &&
                    !this.activity.completed &&
                    !_vm.isClockedOut &&
                    _vm.isCurrentClockType === "OUT"
                      ? _c("UIButton", {
                          staticClass: "font-outfit",
                          attrs: {
                            buttonText: "Clock-out",
                            variant: "blue",
                            size: "md",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleContractorClockInModal(true)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "icon",
                                fn: function () {
                                  return [
                                    _c("ClockIcon", { staticClass: "w-4 h-4" }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "hover-icon",
                                fn: function () {
                                  return [
                                    _c("ClockIcon", { staticClass: "w-4 h-4" }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "disabled",
                                fn: function () {
                                  return [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "16",
                                          height: "16",
                                          viewBox: "0 0 16 16",
                                          fill: "none",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              "clip-path":
                                                "url(#clip0_1989_5285)",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM7.25 3.75V8C7.25 8.25 7.375 8.48438 7.58437 8.625L10.5844 10.625C10.9281 10.8562 11.3938 10.7625 11.625 10.4156C11.8562 10.0687 11.7625 9.60625 11.4156 9.375L8.75 7.6V3.75C8.75 3.33437 8.41562 3 8 3C7.58437 3 7.25 3.33437 7.25 3.75Z",
                                                fill: "#717986",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c("defs", [
                                          _c(
                                            "clipPath",
                                            {
                                              attrs: { id: "clip0_1989_5285" },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  width: "16",
                                                  height: "16",
                                                  fill: "white",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2710562760
                          ),
                        })
                      : _vm._e(),
                    _vm.isCompleted
                      ? _c("CardInfoChip", {
                          staticClass: "mr-4",
                          attrs: { message: "Completed" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "flex flex-row adjustItems" }, [
                  _vm.activity.virtual
                    ? _c("div", { staticClass: "flex flex-col gap-1" }, [
                        _vm.activity.virtual_meeting_link
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "text-blue text-sm font-400 hover:underline",
                                attrs: {
                                  href: _vm.activity.virtual_meeting_link,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.activity.virtual_meeting_link) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.activity.fallback_num
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center gap-1 text-gray-600 text-sm",
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "12",
                                      height: "12",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
                                      },
                                    }),
                                  ]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.activity.fallback_num)),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm.location
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "text-blue text-sm font-400 hover:underline",
                          attrs: {
                            href: _vm.googleMapsLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.location) + " ")]
                      )
                    : _c("p", { staticClass: "text-blue text-sm font-400" }, [
                        _vm._v("n/a"),
                      ]),
                  _c("div", { staticClass: "flex" }, [_vm._t("info")], 2),
                ]),
              ]),
              _c("div", { staticClass: "flex flex-col gap-2 mb-3 mt-3" }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("CalendarIcon", { staticClass: "h-5 w-5" }),
                    _c("p", { staticClass: "projectInfo ml-2" }, [
                      _vm._v(" " + _vm._s(_vm.createdAt) + " "),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("LocationIcon", { staticClass: "h-5 w-5" }),
                    _c("p", { staticClass: "projectInfo ml-2" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.startTime) +
                          " - " +
                          _vm._s(_vm.endTime) +
                          " " +
                          _vm._s(_vm.totalHours && _vm.totalHours) +
                          " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex mb-3" },
                  [
                    _c("StarIcon", { staticClass: "h-5 w-5" }),
                    _c("p", { staticClass: "projectInfo ml-2" }, [
                      _vm._v("Type of activity: " + _vm._s(_vm.typeOfVisit)),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col justify-center gap-3 mb-4 buttonMinHeight",
                },
                [
                  _c("UIButton", {
                    attrs: {
                      buttonText: _vm.notesButtonText,
                      variant: "outline-black",
                      size: "lg",
                      fullWidth: true,
                    },
                    on: { click: _vm.handleShow },
                    scopedSlots: _vm._u([
                      {
                        key: "icon",
                        fn: function () {
                          return [_c("NotesView", { staticClass: "w-4 h-4" })]
                        },
                        proxy: true,
                      },
                      {
                        key: "hover-icon",
                        fn: function () {
                          return [_c("NotesView", { staticClass: "w-4 h-4" })]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm.showLogHours
                    ? _c("UIButton", {
                        attrs: {
                          buttonText: "Log Hours",
                          variant: "outline-black",
                          size: "lg",
                          fullWidth: true,
                        },
                        on: { click: _vm.openTimeTrackerModal },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("ClockIconBlack", {
                                    staticClass: "w-4 h-4",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "hover-icon",
                              fn: function () {
                                return [
                                  _c("ClockIconBlack", {
                                    staticClass: "w-4 h-4",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1688487394
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "flex gap-1 w-full skills-footer items-center" },
            [
              _c("p", { staticClass: "titleTag" }, [_vm._v("Tags:")]),
              this.activity.project_activity_skills?.length > 0
                ? _c(
                    "div",
                    { staticClass: "flex flex-row gap-1 items-center" },
                    [
                      _vm._l(
                        this.activity.project_activity_skills.slice(0, 3),
                        function (skill) {
                          return _c(
                            "div",
                            {
                              key: skill?.skill?.name,
                              staticClass: "skills-chip",
                            },
                            [_vm._v(" " + _vm._s(skill?.skill?.name) + " ")]
                          )
                        }
                      ),
                      this.activity.project_activity_skills.length > 3
                        ? _c("div", [
                            _c("div", { staticClass: "skills-chip-plus" }, [
                              _vm._v(
                                " +" +
                                  _vm._s(
                                    this.activity.project_activity_skills
                                      .length - 3
                                  ) +
                                  " "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              this.activity.project_activity_skills.length === 0 ||
              this.activity.project_activity_skills === undefined
                ? _c("div", { staticClass: "flex items-center notAvaialble" }, [
                    _vm._v(" n/a "),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._t("additions"),
          _c(
            "div",
            { staticClass: "flex w-full justify-between items-center" },
            [_vm._t("actions")],
            2
          ),
        ],
        2
      ),
      _vm.isContractorClockInModal
        ? _c("ContractorClockInModal", {
            attrs: {
              currentUser: _vm.currentUser,
              activity: this.activity,
              project: _vm.project,
            },
            on: {
              close: function ($event) {
                return _vm.toggleContractorClockInModal(false)
              },
            },
          })
        : _vm._e(),
      _vm.showNotesModal
        ? _c("NotesModal", {
            attrs: {
              currentUser: _vm.currentUser,
              activity: this.activity,
              project: _vm.project,
            },
            on: { close: _vm.handleClose },
          })
        : _vm._e(),
      _vm.timeTrackerModalOpened
        ? _c("TimeTrackerModal", {
            attrs: {
              currentUserId: _vm.currentUserId,
              activity: _vm.activity,
              checkDateWeekDisable: _vm.checkDateWeekDisable,
            },
            on: {
              close: function ($event) {
                _vm.timeTrackerModalOpened = false
              },
              openRequestedHoursDeclineReasonModal: (time) => {
                _vm.declineReasonData = time
                _vm.timeTrackerModalOpened = false
                _vm.requestedHoursDeclineReasonModal = true
              },
              openDeclineReasonModal: (time) => {
                _vm.declineReasonData = time
                _vm.timeTrackerModalOpened = false
                _vm.showDeclinedReasonConversationModal = true
              },
            },
            model: {
              value: _vm.timeTrackerModalOpened,
              callback: function ($$v) {
                _vm.timeTrackerModalOpened = $$v
              },
              expression: "timeTrackerModalOpened",
            },
          })
        : _vm._e(),
      _vm.showDeclinedReasonConversationModal
        ? _c("DeclinedReasonConversationModal", {
            staticClass: "z-100",
            attrs: { time: _vm.declineReasonData },
            on: {
              closeDeclineModal: () => {
                _vm.showDeclinedReasonConversationModal = false
                _vm.timeTrackerModalOpened = true
              },
            },
          })
        : _vm._e(),
      _vm.requestedHoursDeclineReasonModal
        ? _c("ViewRequestedHoursDeclineReasonModal", {
            attrs: { time: _vm.declineReasonData },
            on: {
              closeRequestedHoursDeclineModal: () => {
                _vm.requestedHoursDeclineReasonModal = false
                _vm.timeTrackerModalOpened = true
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }